import { OrganizationEntity, PublicAPIKey, UserGroupId, UserPermissions } from '../types';
import { BaseUpdateOrgSettingsRequest } from './orgSettings';
import { PublicApiUpdatable } from './updatable';

export const CREATE_PUBLIC_API_KEY = 'CREATE_PUBLIC_API_KEY';
export const CLEAR_API_KEY = 'CLEAR_API_KEY';

export interface AddApiKeyRequest extends BaseUpdateOrgSettingsRequest {
    name: string;
    appIds: string[];
    groups: UserGroupId[];
    permissions: UserPermissions[];
}
export interface CreatePublicApiKeyResponse {
    orgEntity: OrganizationEntity;
    apiKey: PublicAPIKey;
}

export interface CreateApiKeyData {
    keyValue: string;
    warning?: string;
}

type AddPublicApiKeyData = AddApiKeyRequest;
type CreatePublicApiKeyData = CreateApiKeyData;

export interface TryAddPublicApiKeyAction {
    type: PublicApiUpdatable;
    payload: AddPublicApiKeyData;
}
export interface CreatePublicApiKeyAction {
    type: typeof CREATE_PUBLIC_API_KEY;
    payload: CreatePublicApiKeyData;
}
export interface ClearApiKeyAction {
    type: typeof CLEAR_API_KEY;
}

export const tryAddPublicApiKey: (
    type: PublicApiUpdatable,
    request: AddPublicApiKeyData,
) => TryAddPublicApiKeyAction = (type, request) => {
    return {
        type: type,
        payload: request,
    };
};

export const createPublicApiKey: (payload: CreatePublicApiKeyData) => CreatePublicApiKeyAction = (payload) => {
    return {
        type: CREATE_PUBLIC_API_KEY,
        payload,
    };
};

export const clearApiKey: () => ClearApiKeyAction = () => {
    return {
        type: CLEAR_API_KEY,
    };
};
